export enum CouponDuration {
  Undefined = 'Undefined',
  Forever = 'Forever',
  SingleUse = 'SingleUse',
  Temporal = 'Temporal',
}
